module.exports = __webpack_public_path__ + "static/media/plan-mas-400gb-wom72.9a38651e.svg";